import React, { KeyboardEventHandler, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

// shared
import CoreCheckBox from 'shared/CoreCheckBox';

// components
import LoginInput from '../../../components/login/LoginInput';
import { useLoginMutation } from 'hooks/mutations/user';
import * as S from './style';
import * as Button from './buttons';
import styled, { useTheme } from 'styled-components';
import Icon from 'shared/icons';
import CoreSvg from 'shared/CoreSvg';
import { Grid } from 'styles/styled-components/style';
import CheilLogo from 'shared/../../public/image/logo-cheil.svg';
import BounceLogo from 'shared/../../public/image/logo-bounce.svg';

const Login = () => {
	const theme = useTheme();

	// 자동로그인 체크 여부
	const [checked, setChecked] = useState(false);
	/** 체크 박스 클릭 시 동작 */
	const setCheckBox = () => {
		if (checked) setChecked(false);
		else if (!checked) setChecked(true);
	};

	// ref
	const id_ref = useRef<HTMLInputElement>(null);
	const pwd_ref = useRef<HTMLInputElement>(null);
	const btn_ref = useRef<HTMLButtonElement>(null);

	// mutations
	const { mutate: loginMutate, isLoading: login_loading } = useLoginMutation(checked);

	/** 로그인 클릭 시 동작 */
	const clickLogin = () => {
		if (id_ref.current === null || pwd_ref.current === null) return;

		loginMutate({
			email: id_ref.current?.value,
			password: pwd_ref.current?.value,
		});
	};

	const enterEvent: KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.key !== 'Enter' || btn_ref.current === null) return;
		btn_ref.current.click();
	};

	return (
		<S.Container>
			<S.Header>
				<S.LogoBox>
					<CheilLogo />
				</S.LogoBox>

				<S.WhiteVerticalBorder />

				<S.LogoBox>
					<BounceLogo />
				</S.LogoBox>
			</S.Header>

			<S.Inner>
				<S.LeftBox>
					<S.Logo>
						<img src="/image/login/revised-logo.svg" alt=""></img>
					</S.Logo>

					<S.LeftInfo>
						<S.InfoText>
							IMMS 사용 및 인플루언서 마케팅 관련 문의는
							<br />
							<span>BOUNCE팀</span>으로 문의 바랍니다.
						</S.InfoText>
						<S.WhiteBorder />
						<Grid _padding="10px 0 23px" flex="start" _gap="10px">
							<CoreSvg _fill={theme.colors.gray.gray_white}>
								<Icon.Email />
							</CoreSvg>
							<S.EmailText>edwins.kim@samsung.com</S.EmailText>
						</Grid>
					</S.LeftInfo>
				</S.LeftBox>

				<S.RightBox>
					<S.Form>
						<S.FormTitle>SIGN IN</S.FormTitle>

						<S.FormInner>
							<LoginInput
								_placeholder="ID"
								input_id="login-id"
								_ref={id_ref}
								_onKeyDown={enterEvent}
							/>
							<LoginInput
								type="password"
								_placeholder="Password"
								input_id="login-pwd"
								_ref={pwd_ref}
								_onKeyDown={enterEvent}
							/>

							<S.RememberBox checked={checked}>
								<CoreCheckBox
									check_type="common"
									value="Remember me"
									name="remember-id-input"
									checked_value={checked}
									_onMouseDown={setCheckBox}
								/>
							</S.RememberBox>

							<S.ButtonContainer>
								<Button.Outlined
									bg_color={theme.colors.revised.point}
									bg_color_hovered={'#1ccca3'}
									typo="typo_20b"
									ref={btn_ref}
									onClick={clickLogin}
								>
									{!login_loading && 'Login'}
									{login_loading && <Button.Loading />}
								</Button.Outlined>
								<Link to="/imms/login/password_help">
									<Button.Outlined>Forgot password?</Button.Outlined>
								</Link>
							</S.ButtonContainer>
						</S.FormInner>
					</S.Form>

					<a
						target="_blank"
						href="https://cheilworldwide-my.sharepoint.com/personal/edwins_kim_cheil_com/_layouts/15/guestaccess.aspx?share=EfRTa3rIU2JNp_8TKZrka8oBeBTM1Sha_ZhwKpxoqyHSkQ&e=VgQhfc"
						rel="noreferrer"
					>
						<Button.PointColored>
							IMMS 사용법 알아보기
							<IconWrapper>
								<Icon.LineDownload />
							</IconWrapper>
						</Button.PointColored>
					</a>
				</S.RightBox>
			</S.Inner>
		</S.Container>
	);
};

const BottomButton = styled.button`
	width: 100%;
	height: 70px;
	background-color: ${({ theme }) => theme.colors.revised.dark_blue2};
	color: ${({ theme }) => theme.colors.revised.point};
	${({ theme }) => theme.revised_typo.typo_18b};

	${({ theme }) => theme.common.flexCenter};
	gap: 10px;

	transition: 0.2s;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }) => theme.colors.revised.point};
		color: ${({ theme }) => theme.colors.revised.dark_blue2};

		& > span > svg {
			fill: ${({ theme }) => theme.colors.revised.dark_blue2};
		}
	}
`;

const IconWrapper = styled.span`
	width: 14px;
	height: 16px;

	${({ theme }) => theme.common.flexCenter};

	& > svg {
		fill: ${({ theme }) => theme.colors.revised.point};
	}
`;

export default Login;
